export default __webpack_public_path__ + "language-icon.svg";